import { combineReducers } from 'redux';
import returnFeedReducers from './returnFeedReducers';
import configReducers from './configReducers';
import settingsReducers from './settingsReducers';

export default combineReducers({
  config: configReducers,
  returnFeed: returnFeedReducers,
  settings: settingsReducers,
});
